export type AuditActionResult = 'SUCCESS' | 'FAILED' | 'DENIED';
export type AuditSourceType = 'SYSTEM' | 'INTEGRATION' | 'APPLICATION';

export interface AuditEntry {
  id: string;
  time: Date;
  accountId: string;
  application: string;
  actor: string;
  sourceType: AuditSourceType;
  source: string;
  sourceip: string;
  target: string;
  action: string;
  description: string;
  result: AuditActionResult;
  meta: string;
}

export const DocumentAuditAction = {
  DOCUMENT_UPLOADED: 'DOCUMENT_UPLOADED',
  DOCUMENT_CHANGED: 'DOCUMENT_CHANGED',
  DOCUMENT_ANNOTATED: 'DOCUMENT_ANNOTATED',
  DOCUMENT_PURGED: 'DOCUMENT_PURGED',
  DOCUMENT_TYPE_CHANGED: 'DOCUMENT_TYPE_CHANGED',
  DOCUMENT_STATUS_CHANGED: 'DOCUMENT_STATUS_CHANGED',
} as const;

export type DocumentAuditActionType = (typeof DocumentAuditAction)[keyof typeof DocumentAuditAction];
